import * as React from 'react'
import styled from 'styled-components'
import { Helmet } from 'react-helmet'
import Layout from '../Layout'
import { constants } from '../../constants'
import WhatAreThey from '../details/WhatAreThey'
import Header from '../Header'
import Breadcrumbs from '../details/Breadcrumbs'
import Section from '../common/Section'
import SubSectionBlock from '../common/SubSectionBlock'
import { RedLinkWithArrow } from '../common/LinkWithArrow'
import Favicon from '../../assets/favicon.ico'
import { Ingredient } from '../../data/Ingredient'
import { Language } from '../../Language'
import { FontsContext } from '../../context'
import { withPrefix } from 'gatsby'

interface Props {
  ingredient: Ingredient
  data: any
  messages: any
  language: Language
}

const DetailsIndex = ({ ingredient, data, messages, language }: Props) => {
  const fonts = React.useContext(FontsContext)

  return (
    <>
      <Helmet>
        <meta charSet="utf-8"></meta>
        <title>{`${ingredient.metaTitle}${messages.details.meta.titleSuffix}`}</title>
        <meta name="description" content={ingredient.metaDescription}></meta>
        <meta name="keywords" content={ingredient.metaKeywords}></meta>
        <meta
          property="og:image"
          content="http://www.shiseidogroup.com/cmn_new/img/fb_icon_img.jpg"
        ></meta>
        <link
          rel="shortcut icon"
          href={Favicon}
          type="image/vnd.microsoft.ico"
        ></link>
      </Helmet>
      <Layout
        messages={messages}
        language={language}
        header={() => (
          <Header
            fluidImage={data.logo.childImageSharp.fluid}
            language={language}
            white
            messages={messages}
          />
        )}
      >
        <Breadcrumbs
          title={ingredient.breadcrumbTitle || ingredient.name}
          messages={messages}
          language={language}
        />
        <Section>
          <WhatAreThey
            ingredient={ingredient}
            fluidImage={data.profile.childImageSharp.fluid}
            whatIs={messages.details.whatAreThey.whatIs}
          />
          <Divider />
          <SubSectionBlock
            title={messages.details.whereFrom.title}
            body={ingredient.whereFrom}
          />
          <SubSectionBlock
            title={messages.details.risks.title}
            body={ingredient.risks}
          />
          <SubSectionBlock
            title={messages.details.whyAndHow.title}
            body={ingredient.whyAndHow}
            image={
              data.whyAndHow ? data.whyAndHow.childImageSharp.fluid : undefined
            }
            imageAlt={`${ingredient.name} - ${messages.details.whyAndHow.title}`}
          />
          <LinksBlock>
            <div>
              <RedLinkWithArrow
                fonts={fonts}
                settings={fonts.texts.arrowLink}
                href={withPrefix(`/${language}/`)}
              >
                {messages.details.links.top}
              </RedLinkWithArrow>
            </div>
            <div>
              <RedLinkWithArrow
                fonts={fonts}
                settings={fonts.texts.arrowLink}
                href={withPrefix(`/${language}/ingredients/`)}
              >
                {messages.details.links.ingredients}
              </RedLinkWithArrow>
            </div>
          </LinksBlock>
        </Section>
        <Breadcrumbs
          title={ingredient.breadcrumbTitle || ingredient.name}
          spOnly
          messages={messages}
          language={language}
        />
      </Layout>
    </>
  )
}

const Divider = styled.div`
  display: none;

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    display: block;
    border-bottom: 1px solid #c2c2c2;
    margin-bottom: 108px;
  }
`

const LinksBlock = styled.div`
  display: none;

  @media only screen and (min-width: ${constants.breakpoints.pc}) {
    display: flex;
    margin: 0 85px 80px;
    justify-content: space-between;
  }
`

export default DetailsIndex
